import React from "react";
import TreeList, { Column, FilterRow, SearchPanel, Scrolling, HeaderFilter } from "devextreme-react/tree-list";
import { UsageTreeNode } from "../hooks/useEmailTemplatesController";

type Props = {
    treeNodes: UsageTreeNode[];
    loading: boolean;
    onTemplateClick: (templateName: string) => void;
};

const nodeTypeStyles: Record<string, React.CSSProperties> = {
    module: { fontWeight: 600, fontSize: "1.05em" },
    task: { fontWeight: 500 },
    subtask: { fontStyle: "italic" },
    template: {},
};

const nodeTypeBadges: Record<string, string> = {
    module: "Module",
    task: "Task",
    subtask: "Subtask",
    template: "Template",
};

function labelCellRender(data: { data: UsageTreeNode }) {
    const node = data.data;
    return (
        <span style={nodeTypeStyles[node.nodeType] || {}}>
            {node.label}
        </span>
    );
}

function typeBadgeCellRender(data: { data: UsageTreeNode }) {
    const node = data.data;
    return <span className="text-muted">{nodeTypeBadges[node.nodeType] || ""}</span>;
}

function eventCellRender(data: { data: UsageTreeNode }) {
    const node = data.data;
    if (node.nodeType !== "template") return null;
    return <span>{node.eventType}</span>;
}

export default function EmailTemplatesTreeView({ treeNodes, loading, onTemplateClick }: Props) {
    return (
        <TreeList
            dataSource={treeNodes}
            keyExpr="id"
            parentIdExpr="parentId"
            showBorders
            columnAutoWidth
            wordWrapEnabled
            autoExpandAll={false}
            height={window.innerHeight - 250}
            showRowLines
            rowAlternationEnabled
            onRowClick={(e) => {
                if (e.rowType === "data" && e.data.nodeType === "template" && e.data.templateName) {
                    onTemplateClick(e.data.templateName);
                }
            }}
            hoverStateEnabled
        >
            <SearchPanel visible width={300} placeholder="Search..." />
            <FilterRow visible />
            <HeaderFilter visible />
            <Scrolling mode="virtual" />
            <Column dataField="label" caption="Name" cellRender={labelCellRender} minWidth={300} />
            <Column dataField="nodeType" caption="Level" width={100} cellRender={typeBadgeCellRender}>
                <HeaderFilter allowSearch />
            </Column>
            <Column dataField="eventType" caption="Event" width={130} cellRender={eventCellRender}>
                <HeaderFilter allowSearch />
            </Column>
        </TreeList>
    );
}
